// admin-client/src/components/FeeGauge.jsx
import React from 'react';
import PropTypes from 'prop-types';

export default function FeeGauge({ segments, total }) {
  const safeTotal = Math.max(Number(total) || 0, 0.0001);

  const norm = React.useMemo(
    () =>
      (segments || []).map((s) => {
        const valueNum = Number(s?.value) || 0;
        const pct = (valueNum / safeTotal) * 100;
        return {
          label: s?.label ?? '',
          value: valueNum,
          colorClass: s?.colorClass || 'bg-indigo-500',
          pct: Math.max(0, pct),
        };
      }),
    [segments, safeTotal]
  );

  return (
    <div className="w-full">
      <div className="h-3 w-full rounded bg-gray-100 overflow-hidden flex">
        {norm.map((s) => (
          <div
            key={s.label}
            className={s.colorClass}
            style={{ width: `${s.pct}%` }}
            title={`${s.label} ${s.value}%`}
          />
        ))}
      </div>

      <div className="mt-2 grid grid-cols-2 md:grid-cols-3 gap-2">
        {norm.map((s) => (
          <div key={s.label} className="text-xs text-gray-600 flex items-center gap-2">
            <span className={`inline-block w-3 h-3 rounded ${s.colorClass}`} />
            <span className="truncate">{s.label}</span>
            <span className="ml-auto">{s.value}%</span>
          </div>
        ))}
      </div>
    </div>
  );
}

FeeGauge.propTypes = {
  segments: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      colorClass: PropTypes.string,
    })
  ).isRequired,
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};
